import { AsyncPipe } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { Observable } from 'rxjs';

import { MenuItem } from '../../../models';
import { AuthService } from '../../../../auth';
import { MenuService, TranslationService } from '../../../services';
import { BaseComponent } from '../../base/base.component';

@Component({
  selector: 'app-mobile-menu',
  templateUrl: './mobile-menu.component.html',
  styleUrl: './mobile-menu.component.scss',
  imports: [RouterLink, AsyncPipe],
})
export class MobileMenuComponent extends BaseComponent implements OnInit {
  protected readonly translationService = inject(TranslationService);
  private readonly menuService = inject(MenuService);
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  isAuthenticated$: Observable<boolean>;
  menuItems$: Observable<MenuItem[]>;

  ngOnInit() {
    this.isAuthenticated$ = this.authService.isAuthenticated();
    this.menuItems$ = this.menuService.menuItems(this.router.url);
  }
}
